import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import { Scrollbars } from '../layout/Scrollbars.js';
import { useBreakpointValue } from '../../hooks/useBreakpointValue.js';
import React__default from 'react';
import '../provider/WindowSizeContext.js';
import '../provider/ColorModeContext.js';
import '../../node_modules/lodash/_Stack.js';
import '../../node_modules/lodash/_SetCache.js';
import '../../node_modules/lodash/_equalByTag.js';
import '../../node_modules/lodash/isArguments.js';
import '../../node_modules/lodash/isBuffer.js';
import '../../node_modules/lodash/isTypedArray.js';
import '../../node_modules/lodash/_baseGetTag.js';
import '../../node_modules/lodash/_getTag.js';
import styled from 'styled-components';
var ModalScrollbars = styled(Scrollbars)({
  width: "100%",
  flexGrow: 1,
  display: "flex"
});
var ModalScrollable = React__default.forwardRef(function (props, ref) {
  var autoHeight = useBreakpointValue([false, true]);
  return React__default.createElement(ModalScrollbars, __assign({
    autoHeightMax: "calc(90vh - 64px)",
    autoHeight: autoHeight,
    renderView: function renderView(viewProps) {
      return React__default.createElement(Box, __assign({}, viewProps, {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1
      }));
    }
  }, props, {
    ref: ref
  }));
});
export { ModalScrollable };